module.exports = __webpack_public_path__ + "img/team-default.57fc6b43.svg";